// Prints a document from this server (an item label) in a new window, through the browser's own
// print dialog. Ported from SSG Buy / Trade's app/admin/ui/print.ts — same DYMO LabelWriter 550 /
// 30336 labels, same shape: the window opens first, on the click itself (a pop-up blocker only
// allows window.open right inside a click handler, and the document can take a moment to arrive),
// then fills in once the fetch resolves, and closes again if the fetch fails or the server
// refuses. `credentials: "include"` carries the operator's login cookie, the same as every other
// call this app makes (ui/src/lib/api.ts). When the server refuses, its own plain-language
// `message` is shown (the Lister's error body is `{ error, message }`, flatter than Buy / Trade's
// own `{ error: { message } }` — read accordingly); `failure` covers anything else, such as a
// dropped connection or a response with no body at all.
export async function printDocument(path: string, init: RequestInit | undefined, failure: string): Promise<void> {
  const win = window.open("", "_blank");
  if (!win) throw new Error("Couldn't open the print window. Allow pop-ups for this page and try again.");
  try {
    let response: Response;
    try {
      response = await fetch(path, { credentials: "include", ...init });
    } catch {
      throw new Error("Can't reach the server. Check the connection and try again.");
    }
    if (!response.ok) {
      const body = (await response.json().catch(() => null)) as { message?: string } | null;
      throw new Error(body?.message ?? failure);
    }
    win.document.write(await response.text());
    win.document.close();
    win.focus();
    win.print();
  } catch (e) {
    win.close();
    throw e;
  }
}
